export default function WalletIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="6" width="28" height="20" rx="2" stroke="currentColor" strokeWidth="1.5" />
      <path d="M2 12h28" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="24" cy="20" r="2" fill="currentColor" />
    </svg>
  );
}
